import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PurchaseFlowComponent } from 'src/app/shared/cinejoy/common/purchase-flow/purchase-flow.component';
import * as moment from 'moment-timezone';
import { CreateGroupPopupComponent } from 'src/app/features/group-sharing/create-group-popup/create-group-popup.component';
import { MyTicketCinejoy } from 'src/app/shared/cinejoy/spotlight/models/my-ticket-cinejoy/my-ticket-cinejoy.model';
import { MyTicketScreeningParties } from 'src/app/shared/cinejoy/spotlight/models/my-ticket-screening-parties/my-ticket-screening-parties.model';
import { MatDialog } from '@angular/material/dialog';
import { AgileIntegrationService } from 'src/app/core/services/agile/agile-integration.service';
import { AuthenticationService } from 'src/app/core/services/Authentication/authentication.service';
import { StripePurchasePopupComponent } from 'src/app/features/bulk-purchase/stripe-purchase-popup/stripe-purchase-popup.component';
import { EventType } from 'src/app/features/passport/models/passport.models';
import { environment } from 'src/environments/environment';
import {GroupSharingService, WatchPartyType} from 'src/app/features/group-sharing/group-sharing.service.component';
import {EditGroupPopupComponent} from "../../../group-sharing/edit-group-popup/edit-group-popup.component";
import {UserInvitationService} from "../../../../core/services/user.invitation.service";
import {InvitationSource, WatchPartyRequestFlow} from "../../../../core/models/common.models";
import { SpotlightService } from 'src/app/core/services/spotlight.service';
import { AdminService } from 'src/app/core/services/admin-apis/admin.service';
import { BookmarkPopupComponent } from '../../bookmark-popup/bookmark-popup.component';
import { StripeConfirmationPopupComponent } from 'src/app/features/bulk-purchase/stripe-purchase-popup/stripe-confirmation-popup/stripe-confirmation-popup.component';
import { UnlockPopupComponent } from '../../unlock-popup-component/unlock-popup-component.component';

@Component({
  selector: 'app-mobile-premiere-description',
  templateUrl: './mobile-premiere-description.component.html',
  styleUrls: ['./mobile-premiere-description.component.css']
})
export class MobilePremiereDescriptionComponent implements OnInit {
  private static readonly stripPaymentSessionEventIdKey="stripe_payment_session_id";
  pageUrl:string='';
  isAgileGateWayActive:boolean=environment.agilePurchaseEnabled;
  isMobileModeActive:boolean=false;
  subscriptions:any[];

  @Input() mobilePremiereDetails: any;
  joinButtonDisabled = true;
  timezone:any;
  exsistingGroup:boolean = false;
  eventDetails:any;
  spotlightsTickets: any = new Array();
  showcaseTickets: MyTicketCinejoy[] = new Array();
  screeningPartiesTickets: MyTicketScreeningParties[] = new Array();
  isBuyButtonActive:boolean=false;
  purchaseCallback:boolean=false;
  bulkPurchaseEnabled: boolean = environment.bulkPurchaseEnabled;
  isButtonClicked:boolean=false;
  pass = true
  createGroup = false


  constructor(private router: Router,
              private readonly route: ActivatedRoute,
              private modalService: NgbModal,
              public dialog: MatDialog,
              private agileIntegration: AgileIntegrationService,
              private authService: AuthenticationService,
              private groupsharingService: GroupSharingService,
              private readonly userInvitationService: UserInvitationService,
              private spotlightService: SpotlightService,
              private adminService: AdminService) { }

  ngOnInit(): void {

    if (this.router.url.includes('archive')) {
      this.pass = false
    }

    this.joinButtonEnable();
    this.checkScreenSize();
    this.checkForPurchaseCallback();
    var zone = moment.tz.guess();
    this.timezone = moment(this.mobilePremiereDetails.cinejoySpotlightsSchedule[0].scheduleTimeText).tz(zone).zoneName();
    this.authService.checkUserAuthenticated().subscribe((res)=>{
      if(res.userId > 0){
        this.fetchTickets()
        this.getActiveParties();
        this.getActiveSubscriptions();

      }
    }, err=>{

    })
  }

  bookmarkEvent(eventId: number, isBookmarked: boolean): void {
      this.adminService.getActiveSubscription().subscribe((res) => {
        if (res && res.length > 0 && res[0].purchaseTransactionType === 'SUBSCRIPTION_ALL') {
          const confirmationMessage = isBookmarked 
          ? "Do you want to add this event to your Watchlist?" 
          : "Do you want to remove this event from your Watchlist?";
          if(window.confirm(confirmationMessage)) {
            this.spotlightService.createOrUpdatePassholderWatchlist(eventId, isBookmarked, 'SPOTLIGHT').subscribe((res) => {
              if(res){
                
                this.dialog.open(BookmarkPopupComponent, {
                  data: { isBookmarked },
                });
          
                this.adminService.SpotlightGetEventById(eventId).subscribe((res)=>{
                  this.mobilePremiereDetails = res
                })
              }
            });
          }
          
        } else {
          this.dialog.open(UnlockPopupComponent, {
            panelClass: 'zero-padding-dialog',
            data: { message: 'My Watchlist is an ' + '<a style="color: white !important;" href="/cinejoy/all-access-pass" target="_blank">All-Access Pass</a>' + ' holder’s feature that allows you to bookmark and organize your event and screening experience.' },
          });
        }
      });
  } 
  alreadyBookmarkEvent(isBookmarked: boolean){
    this.dialog.open(BookmarkPopupComponent, {
      data: { isBookmarked }
  }
  )}
  joinButtonEnable(): void {
    let currentTimeText = Date.now();
    this.mobilePremiereDetails.cinejoySpotlightsSchedule = this.mobilePremiereDetails.cinejoySpotlightsSchedule.sort((x: any, y: any) => +new Date(x.scheduleTimeText) - +new Date(y.scheduleTimeText));
    const endOfFestivitiesAdd10 = this.mobilePremiereDetails.cinejoySpotlightsSchedule[this.mobilePremiereDetails.cinejoySpotlightsSchedule.length - 1].scheduleTimeText + (10 * 60 * 60 * 1000);
    setInterval(() => {
      currentTimeText = Date.now();
      if ((this.mobilePremiereDetails.cinejoySpotlightsSchedule[0].scheduleTimeText <= currentTimeText) && (endOfFestivitiesAdd10 >= currentTimeText)) {
        this.joinButtonDisabled = false;
        this.createGroup = false
      } else if (this.mobilePremiereDetails.cinejoySpotlightsSchedule[0].scheduleTimeText > currentTimeText) {
        this.joinButtonDisabled = true;
        this.createGroup = true
      } else {
        this.joinButtonDisabled = true;
        this.createGroup = false
      }
    }, 1000);
  }

  redirect(): void {

    this.authService.checkUserAuthenticated().subscribe({
      next:(user)=>{
        if (user.userId === 0) {
          alert('Please login to Creatics');
          if (this.router.url.includes('archive')) {
            location.href='/login?referer=cinejoy/premiere/more-info/archive'+this.mobilePremiereDetails.eventId+"/"+this.mobilePremiereDetails.name;
            }
            else{
            location.href='/login?referer=cinejoy/premiere/more-info/'+this.mobilePremiereDetails.eventId+"/"+this.mobilePremiereDetails.name;
  
            }
          return;
        }
        else{
          let userAgent = navigator.userAgent;
          let browserName;
          if(userAgent.match(/firefox|fxios/i)){
              browserName = "Firefox";
              alert("Hi,\nFor a better experience please use Google Chrome, Safari or Microsoft Edge.\n\nThank you!")
            }
      
          const currentTimeText = Date.now();
          const redCarpetSchedule = this.mobilePremiereDetails.cinejoySpotlightsSchedule.filter((x: any) => x.scheduleMainText === 'Red Carpet');
          const theaterURL = 'cinejoy/premiere/theater/' + this.mobilePremiereDetails.eventId; // + '/' + this.premiere.name.replaceAll(' ', '-');
          const redCarpetURL = 'cinejoy/premiere/redcarpet/' + this.mobilePremiereDetails.eventId + '/' + this.mobilePremiereDetails.name.replaceAll(' ', '-');
          const groupSharingSchedule = this.mobilePremiereDetails.cinejoySpotlightsSchedule.find((x: any) => x.scheduleMainText === 'GS1')
          const groupSharingScheduleQA = this.mobilePremiereDetails.cinejoySpotlightsSchedule.filter((x: any) => x.scheduleMainText === 'GS2');
      
          if (redCarpetSchedule === undefined || redCarpetSchedule === null) {
      
            this.router.navigate([theaterURL]);
          } else {
            if ((groupSharingSchedule.scheduleTimeText <= currentTimeText) && (currentTimeText <= redCarpetSchedule[0].scheduleTimeText)) {
              this.router.navigate(['cinejoy/spotlight-root/' + this.mobilePremiereDetails.eventId + '/' + this.mobilePremiereDetails.name.replaceAll(' ', '-')])
            }else if ((redCarpetSchedule[0].scheduleTimeText <= currentTimeText) && (this.mobilePremiereDetails.cinejoySpotlightsSchedule[this.getRedCarpetIndex() + 1].scheduleTimeText >= currentTimeText)) {
              this.router.navigate(['cinejoy/spotlight-root/' + this.mobilePremiereDetails.eventId + '/' + this.mobilePremiereDetails.name.replaceAll(' ', '-')])
             // this.router.navigate([redCarpetURL]);
            } else if (groupSharingScheduleQA[0].scheduleTimeText <= currentTimeText) {
             // this.router.navigate(['cinejoy/group-sharing/qa-lobby/' + this.mobilePremiereDetails.eventId])
             this.router.navigate(['cinejoy/spotlight-root/' + this.mobilePremiereDetails.eventId + '/' + this.mobilePremiereDetails.name.replaceAll(' ', '-')])
            } else {
             // this.router.navigate([theaterURL]);
              this.router.navigate(['cinejoy/spotlight-root/' + this.mobilePremiereDetails.eventId + '/' + this.mobilePremiereDetails.name.replaceAll(' ', '-')])
            }
          }
        }},
      error:(err)=>{
        alert('Please login to Creatics');
        if (this.router.url.includes('archive')) {
          location.href='/login?referer=cinejoy/premiere/more-info/archive'+this.mobilePremiereDetails.eventId+"/"+this.mobilePremiereDetails.name;
          }
          else{
          location.href='/login?referer=cinejoy/premiere/more-info/'+this.mobilePremiereDetails.eventId+"/"+this.mobilePremiereDetails.name;

          }
      }
      })

    
  }

  getRedCarpetIndex(): number {
    let i = 0;
    for (const schedule of this.mobilePremiereDetails.cinejoySpotlightsSchedule) {
      if (schedule.scheduleMainText === 'Red Carpet' ) {
        break;
      }
      i++;
    }
    return i;
  }

  open(eventId: number, premiere: any, purchaseStage: string): void {
    if(this.isAgileGateWayActive){
     const modalRef = this.modalService.open(PurchaseFlowComponent, {
       size: 'lg',
       backdrop: 'static',
     })
     modalRef.componentInstance.eventId = eventId;
     modalRef.componentInstance.premiere = premiere;
     modalRef.componentInstance.purchaseStage = purchaseStage;
     modalRef.result.then(
       (result) => {

         this.fetchTickets()
       },
       (reason) => {

       },
     );
    }
    else{
      if(this.isButtonClicked){
        return ;
      }
      this.isButtonClicked=true;
      this.populateCallbackUrl();
      this.authService.checkUserAuthenticated().subscribe(
        (res) => {
          if (res.userId === 0) {
            alert("Please login to creatics to purchase tickets.");
            this.isButtonClicked=false;
            if (this.router.url.includes('archive')) {
              location.href='/login?referer=cinejoy/premiere/more-info/archive'+this.mobilePremiereDetails.eventId+"/"+this.mobilePremiereDetails.name;
              }
              else{
              location.href='/login?referer=cinejoy/premiere/more-info/'+this.mobilePremiereDetails.eventId+"/"+this.mobilePremiereDetails.name;
    
              }
            return;
          }
          else{
            this.openSinglePurchaseDialog(eventId);
          }
        },
        (err) => {
          location.reload();
          this.isButtonClicked=false;
        }
      );

    }
   }

   openSinglePurchaseDialog(eventId: number){

     const currentTime = Date.now();
     const lastScheduleItem = this.mobilePremiereDetails.cinejoySpotlightsSchedule[this.mobilePremiereDetails.cinejoySpotlightsSchedule.length - 1];
     if ((lastScheduleItem.scheduleTimeText  + (5 * 60 * 60 * 1000)) < currentTime) {
       alert('Requested item is currently not on sale.');
       this.isBuyButtonActive=false;
       return;
     }

    localStorage.setItem(MobilePremiereDescriptionComponent.stripPaymentSessionEventIdKey,`${eventId}`);
    this.dialog.open(StripePurchasePopupComponent, {
      panelClass: 'pre-schedule-modalbox',
      width: '415px',
      height: 'auto',
      data: {
        eventId,
        eventType: EventType.SPOTLIGHT,
        mode: 'purchase',
        url:this.pageUrl,
        puchaseType:'singlePurchase',
        purchaseTransactionType:'TICKET'
      }
    }).afterClosed().subscribe((res) => {
      this.isButtonClicked=false;
    })
  }
  openBulkPurchaseDialog(eventId: number): void {

    const currentTime = Date.now();
    const lastScheduleItem = this.mobilePremiereDetails.cinejoySpotlightsSchedule[this.mobilePremiereDetails.cinejoySpotlightsSchedule.length - 1];
    if ((lastScheduleItem.scheduleTimeText  + (5 * 60 * 60 * 1000)) < currentTime) {
      alert('Requested item is currently not on sale.');
    
      return;
    }

    localStorage.setItem(MobilePremiereDescriptionComponent.stripPaymentSessionEventIdKey,`${eventId}`);
    this.dialog.open(StripePurchasePopupComponent, {
      panelClass: 'pre-schedule-modalbox',
      width: '650px',
      height: 'auto',
      data: {
        eventId,
        eventType: EventType.SPOTLIGHT,
        mode: 'purchase',
        url:this.pageUrl,
        puchaseType:'bulkPurchase',
        purchaseTransactionType:'TICKET'
      }
    }).afterClosed().subscribe((res) => {
      this.isButtonClicked=false;
    })
  }
  private populateCallbackUrl() {
    this.pageUrl = window.location.href;
  }

  openDialog(event) {
    if (this.exsistingGroup) {
      this.dialog.open(EditGroupPopupComponent, {
        panelClass: 'pre-schedule-modalbox',
        width: '600px',
        height: '70%',
        data: {
          eventId: event.eventId,
          isPreScheduleEvent: true,
          isEventStarted: this.joinButtonDisabled,
          subscriptions:this.subscriptions
        }
      }).afterClosed().subscribe((res) => {
        this.getActiveParties();
        if (res && res.invitedEmails) {
          this.inviteUser(res);
        }
      });
    } else {
      this.dialog.open(CreateGroupPopupComponent, {
        panelClass: 'pre-schedule-modalbox',
        width: '600px',
        height: '65%',
        data: {
          eventId: event.eventId,
          isPreScheduleEvent: true,
          subscriptions:this.subscriptions
        },
      }).afterClosed().subscribe((res) => {

        if (res) {
          this.getActiveParties()
        }

      });
    }
  }


  fetchTickets(): void {
    //this.isLoading = true;
    this.agileIntegration.fetchTickets().subscribe(
      (response) => {
        // this.isLoading = false;
        const tickets = response.agiletixEvents ? response.agiletixEvents : [];

        this.spotlightsTickets = tickets.filter(
          (ticket) =>
            ticket.type !== undefined &&
            ticket.type !== null &&
            ticket.type.toLowerCase().includes('spotlight')
        );
        this.spotlightsTickets = this.spotlightsTickets.sort(
          (a, b) =>
            new Date(a.StartDateTime).getTime() -
            new Date(b.StartDateTime).getTime()
        );
        if(this.spotlightsTickets.find((v)=> (v.AccessStatus ==='AccessValid' || v.AccessStatus ==='BeforeEvent') && v.ParentID ==  this.mobilePremiereDetails.eventId)){
          this.isBuyButtonActive = true;
        }


      },
      (error) => {
        //this.isLoading = false;

      }
    );
  }


  getActiveParties() {
    this.groupsharingService.getActiveWatchParty(this.mobilePremiereDetails.eventId).subscribe((res) => {
      let item: any = '';
      if (localStorage.getItem('userData')) {
        item = JSON.parse(localStorage.getItem('userData'))
      }
      item['userId'] = item.userID ? item.userID : item.userId
      if (res.filter((v) => v.userId == item.userId).length > 0) {
        this.eventDetails = res.find((v) => v.userId == item.userId);
        this.exsistingGroup = true;
      } else {
        this.exsistingGroup = false;
      }
    }, err => {

    })
  }

  inviteUser(dialogResponse: any) {
    if (!dialogResponse.invitedEmails || !dialogResponse.invitedEmails.length) {
      return;
    }

    for (const email of dialogResponse.invitedEmails) {
      const invitationRequest = {
        emailAddress: email,
        invitedUserName: "Invited User",
        invitationSource: InvitationSource.WATCH_PARTY,
        invitationSourceMetadata: {
          watchPartyRequestFlow: WatchPartyRequestFlow.NEW_PARTICIPANT_ADDED,
          watchPartyParticipantRequest: {
            partyType: WatchPartyType.PRIVATE,
            customRoomId: dialogResponse.customRoomId,
            eventId: dialogResponse.eventId,
            userIds: []
          }
        }
      }

      this.userInvitationService.inviteNewUser(invitationRequest)
        .then(() => {
          console.log(`user: ${email} invited successfully`);
        });
    }
  }

  checkScreenSize(): void {
    const screenWidth = window.innerWidth;
    if (screenWidth <=959) {
      this.isMobileModeActive  = true;

    } else {
      this.isMobileModeActive = false;
    }
  }

  checkForPurchaseCallback() {
   if(this.isMobileModeActive){
    const eventId=  Number(localStorage.getItem(MobilePremiereDescriptionComponent.stripPaymentSessionEventIdKey))
    this.route.queryParams.subscribe(queryParams =>
      {
      if (queryParams.session_id && this.mobilePremiereDetails.eventId===eventId) {
        this.isBuyButtonActive=true;

        this.authService.checkUserAuthenticated().subscribe(
          (res) => {
            if (res.userId === 0) {
              alert('Session expired, Please login back to proceed further');
              if (this.router.url.includes('archive')) {
                location.href='/login?referer=cinejoy/premiere/more-info/archive'+this.mobilePremiereDetails.eventId+"/"+this.mobilePremiereDetails.name +"&"+"session_id"+"=" + queryParams.session_id;
                }
                else{
                location.href='/login?referer=cinejoy/premiere/more-info/'+this.mobilePremiereDetails.eventId+"/"+this.mobilePremiereDetails.name +"&"+"session_id"+"=" + queryParams.session_id;
      
                }
              return;
            }
            else{
              this.openStripPaymentConfirmationPopup(this.mobilePremiereDetails.eventId,queryParams.session_id,EventType.SPOTLIGHT);
            }
          },
          (err) => {
            location.reload();
            console.log(err);
          }
        );
        
      }}
    );
   }
   else{
    const eventId=  Number(localStorage.getItem(MobilePremiereDescriptionComponent.stripPaymentSessionEventIdKey))
    this.route.queryParams.subscribe(queryParams =>
      {
      if (queryParams.session_id && this.mobilePremiereDetails.eventId===eventId) {
        this.isBuyButtonActive=true;
        this.getActiveParties();
      }})

    return;
   }
  }

  openStripPaymentConfirmationPopup(eventId, sessionId, eventType){
    this.dialog.open(StripePurchasePopupComponent, {
      panelClass: 'pre-schedule-modalbox',
      width: '600px',
      minHeight: 'auto',
      maxHeight:'75%',
      data: {
        eventId: eventId,
        eventType: eventType,
        mode: 'callback',
        sessionId: sessionId
      }
    }).afterClosed().subscribe((res) => {
      this.getActiveParties();
      this.populateCallbackUrl();
    })
  }
  getActiveSubscriptions(){
    this.adminService.getActiveSubscription().subscribe(
      {
        next:(data:any[])=>{
          this.subscriptions=data;
          data?.map(
            (item)=>{
              if(item.purchaseTransactionType==='SUBSCRIPTION_ALL'){
                this.isBuyButtonActive=true
              }
              else if (item.purchaseTransactionType==='SUBSCRIPTION_SPOTLIGHT'){
                this.isBuyButtonActive=true
              }
              else if (item.purchaseTransactionType==='SUBSCRIPTION_SHOWCASE'){
                this.isBuyButtonActive=true
              }
            }
          )
      },
      error:(error)=>{
        this.openStripeConfirmationPopup(error);
        console.log("error while fetching subscription", error);
      }

    })
  }
  openStripeConfirmationPopup(error:any): void {
    this.dialog.open(StripeConfirmationPopupComponent, {
      // panelClass: 'pre-schedule-modalbox',
      width: '500px',
      minHeight: '15%',
      maxHeight:'50%',
      position:{
        top:'20px'
      },
      data: {
        invalidUsers:[],
        guestUsers:0,
        emptyTicketCount:0,
        ticketPrice:0 ,
        purchaseTransactionType:"subscriptionError",
        error:error
      }
    }).afterClosed().subscribe((res) => {
      console.log('===== dialog closed with response: ', res);
    })
  }

  initiateBulkPurchase(eventId: number){
    if(this.isButtonClicked){
      return ;
    }
    this.isButtonClicked=true;
    this.populateCallbackUrl();
    this.authService.checkUserAuthenticated().subscribe(
      (res) => {
        if (res.userId === 0) {
          alert("Please login to creatics to purchase tickets.");
          this.isButtonClicked=false;
          if (this.router.url.includes('archive')) {
            location.href='/login?referer=cinejoy/premiere/more-info/archive'+this.mobilePremiereDetails.eventId+"/"+this.mobilePremiereDetails.name;
            }
            else{
            location.href='/login?referer=cinejoy/premiere/more-info/'+this.mobilePremiereDetails.eventId+"/"+this.mobilePremiereDetails.name;
  
            }
          return;
        }
        else{
          this.openBulkPurchaseDialog(eventId);
        }
      },
      (err) => {
        location.reload();
        this.isButtonClicked=false;
      }
    );
  }
}
